import 'd3';
import 'javascript-detect-element-resize/detect-element-resize.js';
import 'javascript-detect-element-resize/jquery.resize.js';
import * as moment from 'moment';
import 'moment/locale/fr.js';
import 'moment/locale/ru.js';
import 'moment/locale/nl.js';
import 'toastr/toastr.js';
import 'lodash';
import 'moment-timezone';
import 'angular-bootstrap-colorpicker/js/bootstrap-colorpicker-module.js';
import 'angular-chronicle/chronicle.js';
import 'innersvg-polyfill/innersvg.js';
import 'angular-xeditable/dist/js/xeditable.js';
import 'ng-file-upload/dist/ng-file-upload-all.js';
import 'signalr/jquery.signalR.js';
import 'marked/lib/marked.js';
import 'sortablejs/modular/sortable.esm.js';
import '../scripts/external/angular-sortable';
import '../scripts/external/sortableFix.js';
import 'bootstrap-daterangepicker/daterangepicker.js';
import 'intl';
import 'intl/locale-data/jsonp/en-US.js';
import * as SimpleMDE from 'simplemde';
import 'ng-simplemde';
import 'leaflet';

window.moment = moment;
window.SimpleMDE = SimpleMDE;
